import React, { useState, useEffect } from 'react'
import LoginAgent from './Login'
import Header from './Header';
import "./css/style.css"
import { MarqueeMassage } from './MarqueeMassage'
import Agents from './Agents';
import Accountstatement from './Accountstatement';
import BetList from "./BetList";
import { toast } from 'react-toastify'
import Downline from "./Downline";
import Market from "./Market";
import Cookies from 'universal-cookie';
import axios from 'axios';
import BetListLive from "./BetlistLive";
import RiskManagement from "./RiskManagement";
import Runningmarketanlysis from './Runningmarketanlysis';
import Banking from "./Banking";
import MyAccount from './MyAccount';
import Profile from './Profile'
import MarketView from './MarketView'
import Transfrredlog from './Transfrredlog'
import Changepassword from './Changepassword';
import ActivityLog from './ActivityLog'
import { CreditReferencePopup } from './CreditReferencePopup'
import AllLog from "./allLog"
import MobileLogin from './MobileLogin';
import { UnderBetList } from "./UnderBetList";
import PlayerBanking from "./PlayerBanking";
import { Alert } from './Alert';
import CasinoControl from '../src/CasinoControl/CasinoControl'
import ClientProfile from './ClientProfile';



toast.configure()

const cookies = new Cookies();


export function detectMobile() {
  var check = false;
  (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
};
window.isMobile = false;
window.isMobile = detectMobile();

var globalArray1 = [];

export default function Combine(props) {


  var eventT = 1;

  if (props.match.params.eventType === 'agents') {
    eventT = 1;
  }
  else if (props.match.params.eventType === 'myAccount' && props.match.params.subType === 'accountCashStatement') {
    eventT = 9;
  }
  else if (props.match.params.eventType === 'agent' && props.match.params.subType === 'myAccount' && props.match.params.belowType === 'accountSummary') {
    eventT = 2;
  }
  else if (props.match.params.eventType === 'myAccount' && props.match.params.subType === 'transferredLog') {
    eventT = 10;
  }
  else if (props.match.params.eventType === 'myAccount' && props.match.params.subType === 'profile') {
    eventT = 11;
  }
  else if (props.match.params.eventType === 'myAccount' && props.match.params.subType === 'activityLog') {
    eventT = 12;
  }
  else if (props.match.params.eventType === 'myAccount') {
    eventT = 2;
  }
  else if (props.match.params.eventType === 'agent' && props.match.params.subType === 'myReport' && props.match.params.belowType === 'downLineProfitLoss') {
    eventT = 3;
  }
  else if (props.match.params.eventType === 'agent' && props.match.params.subType === 'myReport' && props.match.params.belowType === 'marketProfitLoss') {
    eventT = 4;
  }
  else if (props.match.params.eventType === 'agent' && props.match.params.subType === 'betList' && props.match.params.belowType === 'betList') {
    eventT = 5;
  }
  else if (props.match.params.eventType === 'agent' && props.match.params.subType === 'betList' && props.match.params.belowType === 'betListLive') {
    eventT = 6;
  }
  else if (props.match.params.eventType === 'agent' && props.match.params.subType === 'ManageBet' && props.match.params.belowType === 'ManageBet') {
    eventT = 7;
  }
  else if (props.match.params.eventType === 'agentBanking') {
    eventT = 8;
  }
  else if (props.match.params.eventType === 'playerBanking') {
    eventT = 15;
  }
  else if (props.match.params.eventType === 'Runningmarketanlysis') {
    eventT = 14;
  }
  else if (props.match.params.eventType === 'casinoProfitLoss') {
    eventT = 16;
  }
  else if (props.match.params.eventType === 'agent' && props.match.params.subType === 'announcement' && props.match.params.belowType === 'allAnnouncement') {
    eventT = 17;
  }
  else if (props.match.params.eventType === 'agent' && props.match.params.subType === 'banking' && props.match.params.belowType === 'creditReferenceLog') {
    eventT = 18;
  }
  else if (props.match.params.eventType === 'agent' && props.match.params.subType === 'banking' && props.match.params.belowType === 'bankingLog') {
    eventT = 19;
  }
  else if (props.match.params.eventType === 'agent' && props.match.params.subType === 'ManageBet' && props.match.params.belowType === 'riskDownLinePL') {
    eventT = 20;
  }
  else if (props.match.params.eventType === 'UnderBetList') {
    eventT = 21;
  }
  else if (props.match.params.eventType === 'alert') {
    eventT = 22;
  }
  else if (props.match.params.eventType === 'casinocontrol') {
    eventT = 23;
  }

  else if (props.match.params.eventType === 'clientProfile') {
    eventT = 24;
  }


  const [isLoggedIn, setLoggedIn] = useState(null);
  const [tabMenu, setTabMenu] = useState(eventT);
  const [user, setuser] = useState('');
  const [balance, setbalance] = useState(0);
  const [level, setlevel] = useState('');
  const [ShowPassModel, setShowPassModel] = useState(false);
  const [updateBalance, setupdateBalance] = useState(false);
  const [AgentLevel, setAgentLevel] = useState("");
  const [levelNo, setlevelNo] = useState('');
  const [updatedBal, setupdatedBal] = useState(true);
  const [commission, setcommission] = useState(0)
  const [RB, setRB] = useState(0);
  const [TAB, setTAB] = useState(0);
  const [TCB, setTCB] = useState(0);
  const [CE, setCE] = useState(0);
  const [totalAvbal, settotalAvbal] = useState(0);
  const [agentStack, setagentStack] = useState([]);
  const [view, setview] = useState(1);
  const [pro, setpro] = useState(1);






  useEffect(() => {
    globalArray1 = [];
    var ssid = cookies.get('sid');
    if (!ssid) return;
    axios.post('https://flagapi.in/agentapi/getDownlineselfDetaliInfo', {
      sid: ssid,
    })
      .then(result => {
        if (result.status === 200) {
          for (let key in result.data) {
            if (result.data.hasOwnProperty(key)) {
              result.data[key].user = key;
              globalArray1.push(result.data[key]);
            }
          }
          let arr = [];
          globalArray1.map((item) => {
            arr.push(item);

            let totalAvlBal = item.AvlBalance;
            let Exposure = item.Exposure;
            let totalBalance = item.Balance;
            let totalAVB = totalAvlBal + Exposure
            var TotalAllBalance = totalAVB + totalBalance

            setRB(totalAvlBal);
            setTAB(totalBalance);
            setTCB(totalAVB);
            setCE(Math.abs(Exposure));
            settotalAvbal(TotalAllBalance);
          });
        }

      }

      ).catch(e => {
        //setIsError(true);
      });



  }, [isLoggedIn, updateBalance]);





  useEffect(() => {

    if (cookies.get('sid')) {
      setLoggedIn(true);

      var ssid = cookies.get('sid');
      axios.post('https://flagapi.in/agentapi/NewagentInfo', {
        sid: ssid
      })
        .then(result => {

          if (result.status === 200) {
            setuser(result.data.id);
            setbalance(result.data.balance);

            let arr = [];
            let obj = { userid: result.data.id, level: result.data.level }
            arr.push(obj);
            //  console.log(obj,'sfdgf');
            setagentStack(arr);

            if (result.data.level == 0) {
              setlevelNo(0);
              setlevel('ML');
              setAgentLevel('1');

            }
            if (result.data.level == 1) {

              setlevelNo(1);
              setlevel('WL');
              setAgentLevel('2');

            }

            else if (result.data.level == 2) {

              setlevel('SSS');
              setAgentLevel('3');
              setlevelNo(2);

            }

            else if (result.data.level == 3) {

              setlevel('SS');
              setAgentLevel('4');
              setlevelNo(3);

            }

            else if (result.data.level == 4) {

              setlevel('SUP');
              setAgentLevel('5');
              setlevelNo(4);

            }

            else if (result.data.level == 5) {

              setlevel('MA');
              setAgentLevel('6');
              setlevelNo(5);

            }



          }
          else {
            setLoggedIn(false);
            cookies.remove('sid', { path: '/' });

          }
        }

        ).catch(e => {
          //setIsError(true);
        });
    }
    else {
      setLoggedIn(false);
    }

  }, [levelNo, isLoggedIn, updateBalance]);


  useEffect(() => {
    setTabMenu(eventT);

  }, [eventT]);

  const checkUpdateBalance = () => {
    setupdateBalance(!updateBalance);
  }

  const checkShowLogin = (bool) => {
    setLoggedIn(bool);
  }
  const handlepassmodel = () => {
    setShowPassModel(true)
  }
  const handleClosepassmodel = () => {
    setShowPassModel(false)
  }

  const pushAgent = (agent, cla) => {
    let arr = [...agentStack];
    arr.push({ userid: agent, level: cla });
    setagentStack(arr);
  }

  const popAgent = (index) => {
    let arrr = [...agentStack];

    setagentStack(arrr.splice(0, index + 1));
  }

  const changeView = (v) => {
    setview(v);
  }
  const changePro = (v) => {
    setpro(v);
  }
  console.log(agentStack, 'id');

  return (
    <React.Fragment>
      {isLoggedIn === false && window.isMobile === true && <MobileLogin checkShowLogin={checkShowLogin} />}
      {isLoggedIn === false && window.isMobile === false && <LoginAgent checkShowLogin={checkShowLogin} />}
      {isLoggedIn && ShowPassModel && <Changepassword handleClosepassmodel={handleClosepassmodel} />}
      {isLoggedIn && tabMenu != 17 && tabMenu != 18 && tabMenu != 19 && tabMenu != 23 && <Header checkUpdateBalance={checkUpdateBalance} tabMenu={tabMenu} user={user} balance={balance} level={level} />}
      {isLoggedIn && tabMenu === 1 && <Agents popAgent={popAgent} pro={pro} pushAgent={pushAgent} view={view} changeView={changeView} changePro={changePro} agentStack={agentStack} totalAvbal={totalAvbal} CE={CE} TCB={TCB} TAB={TAB} RB={RB} user={user} levelNo={levelNo} AgentLevel={AgentLevel} />}

      {isLoggedIn && tabMenu === 24 && view === 3 && <ClientProfile agentStack={agentStack} pro={pro} />}

      {isLoggedIn && tabMenu === 2 && <MyAccount tabMenu={tabMenu} user={user} level={level} />}
      {isLoggedIn && tabMenu === 9 && <Accountstatement user={user} level={level} />}
      {isLoggedIn && tabMenu === 10 && <Transfrredlog user={user} level={level} />}
      {isLoggedIn && tabMenu === 11 && <Profile handlepassmodel={handlepassmodel} user={user} level={level} />}
      {isLoggedIn && tabMenu === 12 && <ActivityLog user={user} level={level} />}
      {isLoggedIn && tabMenu === 3 && <Downline pushAgent={pushAgent} view={view} changeView={changeView} changePro={changePro} agentStack={agentStack} user={user} level={level} />}
      {isLoggedIn && tabMenu === 4 && <Market />}
      {isLoggedIn && tabMenu === 5 && <BetList user={user} level={level} />}
      {isLoggedIn && tabMenu === 6 && <BetListLive user={user} level={level} />}
      {isLoggedIn && tabMenu === 7 && <RiskManagement isLoggedIn={isLoggedIn} tabMenu={tabMenu} />}
      {isLoggedIn && tabMenu === 8 && level !== 'MA' && <Banking levelNo={levelNo} user={user} balance={balance} checkUpdateBalance={checkUpdateBalance} />}
      {isLoggedIn && tabMenu === 15 && level === 'MA' && <PlayerBanking commission={commission} levelNo={levelNo} user={user} balance={balance} checkUpdateBalance={checkUpdateBalance} />}
      {isLoggedIn && tabMenu === 17 && <MarqueeMassage />}
      {isLoggedIn && tabMenu === 18 && <CreditReferencePopup />}
      {isLoggedIn && tabMenu === 22 && <Alert />}
      {/* {isLoggedIn && tabMenu === 20 && <MarketView /> } */}
      {tabMenu === 23 && <CasinoControl user={user} level={level} />}

      {isLoggedIn && tabMenu === 21 && <UnderBetList user={user} level={level} />}
      {isLoggedIn && tabMenu === 14 && <Runningmarketanlysis/>}
      {/*  {isLoggedIn && tabMenu === 3 && <Downline/>}
     {isLoggedIn && tabMenu === 15 && <PlayerBanking  balance={balance} checkUpdateBalance = {checkUpdateBalance}/>}
    
     {isLoggedIn && tabMenu === 14 && <Runningmarketanlysis/>}
     {isLoggedIn && tabMenu === 16 && <CasinoReport/>} */}

    </React.Fragment>
  )
}
